import { WithAccountId } from '@mews-commander/types';
import { PaymentsTablesSegmented } from './tables/PaymentsTablesSegmented';

export const CompanyPaymentsTab = ({ accountId }: WithAccountId) => (
    <PaymentsTablesSegmented accountId={accountId} isCompany />
);
